import httpClient from "./http-client.service";

export const coreService = { httpClient };
